<template>
  <div class="audio3d">
    <switchCom-component class="switchPos"></switchCom-component>
  </div>
</template>

<script>
var postData = {};
import { mapState, mapMutations } from "vuex";
import SwitchCom from "./SwitchCom.vue";
import { onBeforeUnmount, ref, getCurrentInstance } from "vue";

export default {
  name: "Audio3D",
  props: {
    audioList: {
      default: [],
    },
    audioXYByMy: {
      default: [],
    },
    canvas: {
      default: {},
    },
    sceneType: {
      default: "",
    },
    begin: {
      default: [],
    },
  },
  data() {
    return {
      audioCtx: null,
      audioEl: null,
      audioPosition: null,
      AudioContext: null,
      sourceNode: null,
      pannerNode: null,
      isSpatialized: false,

      context: null,
      oscillator: null,
      bypasser: null,
      songList: null,
      sourceList: [],
      isDrumPlay: true,
      isShowSpaceAudio: true,
      context: null,
    };
  },
  components: {
    "switchCom-component": SwitchCom,
  },
  created() {},
  async mounted() {
    this.getSongList();
  },
  setup() {
    let { proxy } = getCurrentInstance();
    onBeforeUnmount(() => {
      proxy.stopAudio();
    });
  },
  watch: {
    // 监控画布音源坐标并传递到process中
    audioXYByMy(newVal, oldVal) {
      // console.log(newVal[1].x,'newVal');
      let obj = {
        audioXYByMy: newVal,
        type: 1,
        sceneType: this.sceneType,
        isDrumPlay: this.isDrumPlay,
      };
      if (this.bypasser) {
        this.bypasser.port.postMessage(obj);
      }
    },

    // 监控画布是否允许鼓声播放并传递到process中（点击控制）
    isDrumPlay(newVal, oldVal) {
      let obj = {
        type: 2,
        isDrumPlay: newVal,
      };
      this.bypasser.port.postMessage(obj);
    },

    // 空间音频及非空间音频指令切换并传递到process中（点击控制）
    isShowSpaceAudio(newVal, oldVal) {
      let obj = {
        type: 3,
        isShowSpaceAudio: newVal,
      };
      this.bypasser.port.postMessage(obj);
    },
  },
  methods: {
    // 双击动块图标，切换鼓声是否播放
    getIsDrumPlay(val) {
      this.isDrumPlay = val;
    },

    //worklet
    ...mapMutations(["getXhrList"]),
    async getSongList() {
      const allAudioPromise = this.audioList.map((item) => {
        return new Promise((resolve, reject) => {
          // 创建一个xhr
          var xhr = new XMLHttpRequest();
          xhr.open("GET", item.audioSrc, true);

          // 设置响应类型为 arraybuffer
          xhr.responseType = "arraybuffer";
          xhr.onload = async () => {
            // console.log(xhr, "xhr", item.audioSrc);
            var audioContext = new (window.AudioContext ||
              window.webkitAudioContext)();
            var audioData = xhr.response;
            const decodedAudioData = await audioContext.decodeAudioData(
              audioData
            );
            xhr.decodedAudioData = decodedAudioData;
            audioContext.close();

            resolve({
              src: item.audioSrc,
              id: item.id,
              sceneType: item.sceneType,
              xhr: xhr,
            });
          };

          xhr.send();
        });
      });

      const audioRes = await Promise.all(allAudioPromise);
      this.list = audioRes;

      this.getXhrList(audioRes);
    },
    async startPlay() {
      //create a new AudioContext
      let AudioContext = window.AudioContext || window.webkitAudioContext;
      this.context = new AudioContext();
      // this.context.destination.channelCount = 2;

      //Add our Processor module to the AudioWorklet
      await this.context.audioWorklet
        .addModule("/space/worklet/processor.js")
        .then(() => {
          //Create an oscillator and run it through the processor
          let oscillator = new OscillatorNode(this.context);
          this.bypasser = new AudioWorkletNode(
            this.context,
            "my-worklet-processor",
            { outputChannelCount: [2] }
          );

          //Connect to the context's destination and start
          oscillator.connect(this.bypasser).connect(this.context.destination);
          oscillator.start();

          // 数据传递
          postData.dataList = [];
          for (let i = 0; i < this.list.length; i++) {
            var decodedAudioData = [];
            // console.log(this.list[i].xhr.decodedAudioData);
            decodedAudioData.push(
              this.list[i].xhr.decodedAudioData.getChannelData(0)
            );
            let data = {
              id: this.list[i].id,
              sceneType: this.list[i].sceneType,
              src: this.list[i].src,
              // xhr: this.list[i].xhr.response,
              decodedAudioData: decodedAudioData,
              duration: this.list[i].xhr.decodedAudioData.duration,
              sampleRate: this.list[i].xhr.decodedAudioData.sampleRate,
            };
            // console.log(this.list[0].xhr.response);
            // console.log(this.list[0].xhr.decodedAudioData.getChannelData(0))
            postData.dataList.push(data);
          }
          postData.audioXY = {
            audioXY: this.audioXYByMy,
          };
          postData.type = 0;
          postData.sceneType = this.sceneType;
          postData.isDrumPlay = this.isDrumPlay;
          this.bypasser.port.postMessage(postData);
        })
        .catch((e) => console.log(e));
    },
    startPlayPre() {
      if (this.context == null) {
        this.startPlay();
      } else {
        this.context.resume();
      }
    },
    pausePlay() {
      this.context.suspend();
    },
    stopAudio() {
      if (this.context) {
        try {
          this.context.close();
        } catch (error) {
          console.log("error closing context", error);
        }
        this.context = null;
      }
    },
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
.buttStyle {
  position: absolute;
  top: 100px;
  left: 150px;
  z-index: 10;
}

.switchPos {
  position: absolute;
  top: 17px;
  right: 222px;
}
</style>
